import { type LeadContact } from "services/suno-comms/types/lead-contact.type";

export const getContactFullName = (contact?: Partial<LeadContact>) => {
  return [contact?.first_name, contact?.last_name].filter(Boolean).join(" ");
};
